import { render } from "./FrameTypes.vue?vue&type=template&id=53750b08&scoped=true"
import script from "./FrameTypes.vue?vue&type=script&lang=js"
export * from "./FrameTypes.vue?vue&type=script&lang=js"

import "./FrameTypes.vue?vue&type=style&index=0&id=53750b08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53750b08"]])

export default __exports__